import { render, staticRenderFns } from "./AccountsPage.vue?vue&type=template&id=ed5ce270&scoped=true"
import script from "./AccountsPage.vue?vue&type=script&lang=js"
export * from "./AccountsPage.vue?vue&type=script&lang=js"
import style0 from "./AccountsPage.vue?vue&type=style&index=0&id=ed5ce270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5ce270",
  null
  
)

export default component.exports